

import React, { useEffect, useState } from 'react';
import './menuiteams.css';
import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { ArrowBack } from "@mui/icons-material"; // optional icon


// Set the app element for accessibility
Modal.setAppElement('#root');

const MenuitemsTable = ({ setShowLogin, parentId }) => {
  const [dishes, setDishes] = useState([]);
  const [filteredDishes, setFilteredDishes] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVegSelected, setIsVegSelected] = useState(false);
  const [isNonVegSelected, setIsNonVegSelected] = useState(false);
  const [orderType, setOrderType] = useState("DINE_IN"); // Single state for order type
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDish, setSelectedDish] = useState(null);
  const [cartItems, setCartItems] = useState([" "]);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const [enable, setEnable] = useState([]);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [description, setDescription] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  // Function to fetch cart items and update quantities
  const fetchCartItems = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) {
      return;
    }

    try {
      const cartUrl = `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`;
      const response = await axios.get(cartUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("🛒 Cart fetch response:", response.data);

      // Extract cart items from response (handling different response formats)
      let cartItems = [];
      if (Array.isArray(response.data) && response.data.length > 0) {
        cartItems = response.data[0]?.cartItems || [];
      } else if (response.data && response.data.cartItems) {
        cartItems = response.data.cartItems;
      } else if (Array.isArray(response.data)) {
        cartItems = response.data;
      }

      // Update quantities state
      const newQuantities = {};
      cartItems.forEach(item => {
        if (item.dish && item.dish.dishId) {
          newQuantities[item.dish.dishId] = item.quantity;
        } else if (item.dishId) {
          // Handle case where dish object might be nested differently
          newQuantities[item.dishId] = item.quantity;
        }
      });

      setQuantities(newQuantities);
      console.log("✅ Updated quantities from cart:", newQuantities);

    } catch (error) {
      if (error.response?.status === 404) {
        console.log("🛒 No cart found (404) - setting empty quantities");
        setQuantities({});
      } else {
        console.error("❌ Error fetching cart:", error);
      }
    }
  };

  // Call this when component mounts and when userId changes
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      fetchCartItems();
    }
  }, []);


  const handleNavigate = () => {
    navigate("/cartsdata");
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleToggleTooltip = (dishName, description) => {
    if (activeTooltip === dishName) {
      setActiveTooltip(null);
      setDescription("");
    } else {
      setActiveTooltip(dishName);
      setDescription(description || "");
    }
  };

  const totalPrice = cartItems.reduce((acc, item) => {
    return acc + item.price * item.quantity * 0.9;
  }, 0);

  const handleAddToFavorites = async (dishId) => {
    console.log("🟢 handleAddToFavorites RECEIVED parameter:", dishId);
    console.log("Type of dishId:", typeof dishId);

    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) {
      alert("Please log in to add items to favorites.");
      return;
    }

    const dish = dishes.find(d => d.dishId === dishId);
    console.log("Dish verification - Looking for dishId:", dishId);
    console.log("Found dish:", dish);

    if (!dish) {
      console.error("❌ Dish not found for ID:", dishId);
      alert(`Error: Dish ID ${dishId} not found.`);
      return;
    }

    const apiUrl = `https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`;
    console.log("📤 Final API URL:", apiUrl);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const responseText = await response.text();
      console.log("📄 Response:", responseText);

      if (response.ok) {
        alert(`✅ "${dish.dishName}" added to favorites!`);
      } else if (response.status === 404) {
        alert(`❌ "${dish.dishName}" not found in system.`);
      } else if (response.status === 409) {
        alert("❤️ Already in favorites!");
      } else {
        alert(`❌ Error: ${responseText}`);
      }

    } catch (error) {
      console.error("Network error:", error);
      alert("❌ Network error.");
    }
  };

  const [isOn, setIsOn] = useState(false);
  const userId = localStorage.getItem('userId');

  // ✅ Handle order type selection
  const handleOrderTypeClick = async (type) => {
    const newOrderType = type === "Dining" ? "DINE_IN" : "TAKEAWAY";
    setOrderType(newOrderType);

    console.log(`${newOrderType} selected`);

    // Update cart with new order type if user is logged in
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (userId && token) {
      try {
        await updateCartOrderType(userId, token, newOrderType);
        console.log(`✅ Cart updated with order type: ${newOrderType}`);
      } catch (error) {
        console.error("❌ Failed to update cart order type:", error);
      }
    }
  };

  // ✅ Function to update cart order type
  const updateCartOrderType = async (userId, token, newOrderType) => {
    try {
      // First check if cart exists
      const cartExists = await checkCartExists(userId, token);

      if (cartExists) {
        // Update existing cart order type
        const updateCartUrl = `https://backend.maamaas.com/food/api/cart/update-order-type/${userId}?orderType=${newOrderType}`;

        const response = await axios.put(updateCartUrl, null, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        console.log("✅ Cart order type updated:", response.data);
        return response.data;
      } else {
        // Create new cart with selected order type
        const newCart = await createNewCart(userId, token, newOrderType);
        return newCart;
      }
    } catch (error) {
      console.error("❌ Failed to update cart order type:", error);
      throw error;
    }
  };

  const addToCart = async (item, quantity = 1) => {
    console.log("addToCart called with dishId:", item.dishId);

    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      setShowLogin(true);
      return;
    }

    if (!token) {
      alert("Please log in to add items to cart.");
      return;
    }

    // ✅ Ensure cart exists with current order type before adding item
    const cartExists = await checkCartExists(userId, token);
    if (!cartExists) {
      await createNewCart(userId, token, orderType);
    }

    // ✅ Add item to cart
    const addItemUrl = `https://backend.maamaas.com/food/api/cart/add/${userId}`;
    const data = {
      dishId: item.dishId,
      quantity: quantity,
    };

    try {
      const response = await axios.post(addItemUrl, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        console.log("✅ Item successfully added to cart:", response.data);

        // ✅ Refresh cart quantities from server
        await fetchCartItems();

        // Update local state
        setCartItems((prevItems) => {
          const existingItem = prevItems.find(
            (cartItem) => cartItem.dishId === item.dishId
          );
          if (existingItem) {
            return prevItems.map((cartItem) =>
              cartItem.dishId === item.dishId
                ? { ...cartItem, quantity }
                : cartItem
            );
          } else {
            return [...prevItems, { ...item, quantity }];
          }
        });

        setIsModalOpen(true);
        setTimeout(() => {
          if (!isHovered) {
            setIsModalOpen(false);
          }
        }, 2000);
      }
    } catch (error) {
      console.error("❌ Error adding item to cart:", error);

      if (error.response?.status === 500) {
        alert("Cart error. Please try adding the item again.");
      } else {
        alert("Failed to add item to cart. Please try again.");
      }
    }
  };

  // ✅ Check if cart exists
  const checkCartExists = async (userId, token) => {
    try {
      const checkCartUrl = `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`;
      const response = await axios.get(checkCartUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("🛒 Cart check response:", response.data);

      if (Array.isArray(response.data) && response.data.length > 0) {
        const hasItems = response.data[0]?.cartItems?.length > 0;
        console.log("🛒 Cart exists with array format, has items:", hasItems);
        return hasItems;
      } else if (response.data && response.data.cartItems) {
        const hasItems = response.data.cartItems.length > 0;
        console.log("🛒 Cart exists with object format, has items:", hasItems);
        return hasItems;
      } else if (response.data) {
        const hasItems = response.data.length > 0;
        console.log("🛒 Cart exists with direct format, has items:", hasItems);
        return hasItems;
      }

      console.log("🛒 Cart exists but is empty");
      return false;

    } catch (error) {
      if (error.response?.status === 404) {
        console.log("🛒 No cart exists (404)");
        return false;
      }
      console.error("Error checking cart existence:", error);
      return true;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      console.log("🧭 Menu mounted — fetching cart...");
      console.log("UserId:", userId);

      const exists = await checkCartExists(userId, token);

      if (!exists) {
        console.log("🧩 Creating new cart...");
        await createNewCart(userId, token, orderType);
      } else {
        console.log("✅ Cart already exists, not creating a new one.");
      }
    };

    fetchData();
  }, []);

  // ✅ FIXED: Create cart with required orderType with success/failure alerts
  const createNewCart = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    try {
      const createCartUrl = `https://backend.maamaas.com/food/api/cart/create/${userId}?orderType=${orderType}`;

      const response = await axios.post(createCartUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // alert(`✅ ${orderType === "DINE_IN" ? "Dining" : "Takeaway"} cart created successfully!`);
      console.log("Cart created:", response.data);
    } catch (error) {
      console.error("Error creating cart:", error);
      alert("❌ Failed to create cart.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      if (!vendorId || !token) {
        console.warn("⚠️ vendorId or token not found in localStorage");
        setError(new Error("vendorId or authToken missing"));
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const dishData = Array.isArray(data) ? data : data.data || [];

        const validDishData = dishData.filter(
          (item) => item !== null && item !== undefined
        );

        const filteredData = validDishData.filter((item) => {
          const parentCheck = parentId
            ? Number(item.parentId) === Number(parentId)
            : Number(item.parentId) !== 0;
          const statusCheck = item.menuStatus === "Enable";
          const stockCheck = Number(item.balanceQuantity) > 0;
          return parentCheck && statusCheck && stockCheck;
        });

        console.log("Filtered Dishes:", filteredData);
        setDishes(filteredData);
        setFilteredDishes(filteredData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [parentId]);

  const handleFilterClick = (type) => {
    if (type === "Veg") {
      setIsVegSelected(true);
      setIsNonVegSelected(false);
      setFilteredDishes(dishes.filter((dish) => dish.tag === "Veg"));
    } else if (type === "Non-Veg") {
      setIsVegSelected(false);
      setIsNonVegSelected(true);
      setFilteredDishes(dishes.filter((dish) => dish.tag === "Non_Veg"));
    } else if (type === "All") {
      setIsVegSelected(false);
      setIsNonVegSelected(false);
      setFilteredDishes(dishes);
    }
  };

  const openModal = (dish) => {
    setSelectedDish(dish);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDish(null);
  };

  const increaseQuantity = async (dishId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) {
      alert("Please log in first.");
      return;
    }

    const currentQuantity = quantities[dishId] || 0;
    const newQuantity = currentQuantity + 1;

    console.log("📤 Increasing quantity for dishId:", dishId, "from", currentQuantity, "to", newQuantity);

    try {
      // Use query parameters as the backend expects
      const apiUrl = `https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&dishId=${dishId}`;

      console.log("📤 PUT Request URL:", apiUrl);

      const response = await axios.put(apiUrl, null, { // null for request body
        headers: {
          "Authorization": `Bearer ${token}`,
          "accept": "*/*"
        }
      });

      if (response.status === 200) {
        console.log("✅ Quantity increased successfully:", response.data);

        // Update local state immediately
        setQuantities((prev) => ({
          ...prev,
          [dishId]: newQuantity,
        }));

        // Also refresh from server to ensure sync
        await fetchCartItems();
      }
    } catch (err) {
      console.error("❌ Failed to increase quantity");
      console.error("Error details:", {
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
        message: err.message
      });

      // More specific error messages
      if (err.response?.status === 401) {
        alert("Session expired. Please log in again.");
      } else if (err.response?.status === 404) {
        alert("Item not found in cart. Please add it first.");
      } else {
        alert(err.response?.data?.message || "Unable to update quantity right now. Please try again.");
      }
    }
  };

  const decreaseQuantity = async (item) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    const dishId = item.dishId;

    if (!userId || !token || !dishId) {
      console.error("❌ Missing credentials");
      alert("Please log in first.");
      return;
    }

    const currentQty = quantities[dishId] || 1;

    // If quantity is 1 and decreasing, set quantity to 0 (which should remove it)
    if (currentQty === 1) {
      const newQty = 0;
      console.log("🗑️ Removing item by setting quantity to 0 for dishId:", dishId);

      try {
        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQty}&dishId=${dishId}`;

        console.log("📤 Remove item URL:", apiUrl);

        const response = await axios.put(apiUrl, null, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "accept": "*/*"
          }
        });

        if (response.status === 200) {
          console.log("✅ Item removed successfully by setting quantity to 0");

          // Remove from local state completely (like cart page does)
          setQuantities((prev) => {
            const newQuantities = { ...prev };
            delete newQuantities[dishId];
            return newQuantities;
          });

          // Also update cartItems state
          setCartItems((prevItems) =>
            prevItems.filter(cartItem => cartItem.dishId !== dishId)
          );

          // Refresh from server to ensure sync
          await fetchCartItems();
        }
      } catch (err) {
        console.error("❌ Failed to remove item");
        console.error("Error details:", {
          status: err.response?.status,
          data: err.response?.data,
          message: err.message
        });
        alert("Failed to remove item from cart. Please try again.");
      }
      return;
    }

    // Normal decrease for quantities > 1
    const newQty = currentQty - 1;
    console.log("📤 Decreasing quantity for dishId:", dishId, "from", currentQty, "to", newQty);

    try {
      const apiUrl = `https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQty}&dishId=${dishId}`;

      console.log("📤 PUT Request URL:", apiUrl);

      const response = await axios.put(apiUrl, null, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "accept": "*/*"
        }
      });

      if (response.status === 200) {
        console.log("✅ Quantity decreased successfully:", response.data);

        // Update local state
        setQuantities((prev) => ({
          ...prev,
          [dishId]: newQty,
        }));

        // Refresh from server to ensure sync
        await fetchCartItems();
      }
    } catch (err) {
      console.error("❌ Failed to decrease quantity");
      console.error("Error details:", err.response?.data || err.message);
      alert("Unable to update quantity right now. Please try again.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading dishes: {error.message}</div>;
  }

  const handleViewCartClick = () => {
    navigate('/cartsdata');
  };

  return (
    <div style={{ marginTop: '20px' }} className='menuiteams-data'>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          marginBottom: "1rem",
          justifyContent: "center",
        }}
      >
        <style>
          {`
/* Menu Items Responsive Styles */

/* Hide scrollbars */
.offers-containers::-webkit-scrollbar,
.menuiteams-data::-webkit-scrollbar {
  display: none;
}
.offers-containers,
.menuiteams-data {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Standard Large Screens (1025px - 1199px) */
@media (min-width: 1025px) and (max-width: 1199px) {
    .menuiteams-data {
        position: relative;
        margin-top: 25px !important;
        right: 23px;
        padding: 0px 28px;
    }
  
  .offers-containers {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 22px;
    margin-top: 0 !important;
  }
  
  .offer-image {
    height: 200px !important;
  }
  
  .card-body {
    padding: 18px !important;
  }
  
  .card-title {
    font-size: 20px !important;
  }
  
  .responsive-button-group {
    gap: 20px !important;
    margin-bottom: 25px !important;
  }
  
  .responsive-button-group button {
    width: 150px !important;
    height: 60px !important;
    font-size: 1.25rem !important;
  }
  .four-buttons {
        min-width: 95px !important;
        height: 50px !important;
        font-size: 1rem !important;
        padding: 12px 20px !important;
  }
}

/* Medium Screens (769px - 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .menuiteams-data {
    margin-top: 20px !important;
    padding: 0 20px;
  }
  
  .offers-containers {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-top: 0 !important;
    padding-bottom:60px !important;
  }
  .offers-cards {
    margin-bottom: 10px; /* Ensure space between cards */
  }
  
  .offer-image {
    height: 180px !important;
  }
  
  .card-body {
    padding: 16px !important;
    border-radius: 10px !important;
  }
  
  .card-title {
    font-size: 18px !important;
  }
  
  .responsive-button-group {
    gap: 15px !important;
    margin-bottom: 20px !important;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .responsive-button-group button {
    width: 140px !important;
    height: 55px !important;
    font-size: 1.1rem !important;
    padding: 12px 24px !important;
  }
  
  /* Tooltip adjustments for tablet */
  .card-title > div[style*="width: 22px"] {
    width: 20px !important;
    height: 20px !important;
    font-size: 12px !important;
  }
  
  .card-title > div[style*="width: 22px"] > div {
    width: 200px !important;
    top: -120px !important;
    right: -20px !important;
  }
}

/* Enhanced Button Styles for Medium+ Screens */
@media (min-width: 769px) {
  .responsive-button-group button {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    font-weight: 700 !important;
    border-width: 3px !important;
  }
  
  .responsive-button-group button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  }
  
  .responsive-button-group button:active {
    transform: translateY(0);
  }
}

/* Price Styling Enhancements */
@media (min-width: 769px) {
  .card-body span[style*="color: gray"] {
    font-size: 18px !important;
  }
  
  .card-body span[style*="margin-left: 15px"] {
    font-size: 22px !important;
    font-weight: 600;
  }
  
  .fa-indian-rupee-sign {
    font-size: 16px !important;
  }
}

/* Quantity Controls Enhancement */
@media (min-width: 769px) {
  .border.p-2.mt-2 {
    border-radius: 50px !important;
    transition: all 0.3s ease;
  }
  
  .border.p-2.mt-2:hover {
    background: #9a4dac !important;
  }
  
  .border.p-2.mt-2 button {
    transition: all 0.2s ease;
  }
  
  .border.p-2.mt-2 button:hover {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }
}

/* Modal Enhancements for Larger Screens */
@media (min-width: 769px) {
  .ReactModal__Content {
    max-width: 600px !important;
    height: 80px !important;
    top: 93% !important;
    border-radius: 15px !important;
  }
  
  .ReactModal__Content > div {
    padding: 10px 15px !important;
    height: 80px !important;
    border-radius: 15px !important;
  }
  
  .ReactModal__Content button {
    padding: 10px 24px !important;
    font-size: 16px;
    transition: all 0.3s ease;
    border-radius: 15px !important;
  }
  
  .ReactModal__Content button:hover {
    background: #9a4dac !important;
    transform: translateY(-1px);
    border-radius: 15px !important;
  }
}

/* Heart Icon Enhancement */
@media (min-width: 769px) {
  .fa-heart {
    transition: all 0.3s ease !important;
  }
  
  .fa-heart:hover {
    transform: scale(1.2);
    color: #ff4081 !important;
  }
}

/* Grid Layout Optimization */
@media (min-width: 1400px) {
  .offers-containers {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
}

/* High DPI Screen Optimization */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .offer-image {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
}

/* Reduced Motion for Accessibility */
@media (prefers-reduced-motion: reduce) {
  .offers-cards,
  .responsive-button-group button,
  .border.p-2.mt-2,
  .fa-heart {
    transition: none !important;
  }
  
  .offers-cards:hover {
    transform: none !important;
  }
}

/* Container Max Width for Ultra-wide Screens */
@media (min-width: 1600px) {
  .menuiteams-data {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
  }
}

/* Offer Cards Dynamic Width System - FIXED FOR SINGLE ITEM */
.offers-containers {
  display: grid;
  gap: 25px;
  margin-top: 0 !important;
  padding: 20px 0;
  width: 100%;
  justify-content: center;
}

/* 1 Item - Full width with reasonable max width */
.offers-containers:has(.offers-cards:only-of-type) {
  grid-template-columns:repeat(2, minmax(260px, 1fr));
  max-width: 300px;
  margin: 0 auto;
}

/* 2 Items - 2 equal columns */
.offers-containers:has(.offers-cards:nth-child(2):last-child) {
  grid-template-columns: repeat(2, minmax(300px, 1fr));
  max-width: 1200px;
  margin: 0 auto;
}

/* 3 Items - 3 equal columns */
.offers-containers:has(.offers-cards:nth-child(3):last-child) {
  grid-template-columns: repeat(3, minmax(260px, 1fr));
  max-width: 1200px;
  margin: 0 auto;
}

/* 4 Items - 4 equal columns */
.offers-containers:has(.offers-cards:nth-child(4):last-child) {
  grid-template-columns: repeat(4, minmax(250px, 1fr));
  max-width: 1400px;
  margin: 0 auto;
}

/* 5+ Items - Standard responsive grid */
.offers-containers:has(.offers-cards:nth-child(5)) {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

/* Individual Card Styling */
.offers-cards {
  transition: all 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: fit-content;
  width: 100%;
}

/* Card hover effects */
.offers-cards:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(177, 93, 198, 0.15);
}

/* Image sizing */
.offer-image {
  width: 100%;
  object-fit: cover;
  border-bottom: 1px solid #eee;
}

/* Dynamic image heights based on item count */
.offers-containers:has(.offers-cards:only-of-type) .offer-image {
  height: 280px;
}

.offers-containers:has(.offers-cards:nth-child(2):last-child) .offer-image {
  height: 220px;
}

.offers-containers:has(.offers-cards:nth-child(3):last-child) .offer-image {
  height: 200px;
}

.offers-containers:has(.offers-cards:nth-child(4):last-child) .offer-image {
  height: 180px;
}

.offers-containers:has(.offers-cards:nth-child(5)) .offer-image {
  height: 200px;
}

/* Card body padding adjustments */
.offers-containers:has(.offers-cards:only-of-type) .card-body {
  padding: 25px !important;
}

.offers-containers:has(.offers-cards:nth-child(2):last-child) .card-body {
  padding: 20px !important;
}

.offers-containers:has(.offers-cards:nth-child(3):last-child) .card-body {
  padding: 18px !important;
}

.offers-containers:has(.offers-cards:nth-child(4):last-child) .card-body {
  padding: 16px !important;
}
// @media (min-width: 2000px) {
// .offers-containers:has(.offers-cards:nth-child(5)) {
//     grid-template-columns: repeat(, minmax(250px, 1fr)) !important;
//      max-width: 1600px !important;
//      padding-bottom:20px !important;
//   }

// }
/* Large Screens (1440px and above) - FIXED FOR SINGLE ITEM */
@media (min-width: 1440px) {
  .offers-containers {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 25px !important;
    max-width: 1800px !important;
  }
  
  /* Single item - centered with good width */
  .offers-containers:has(.offers-cards:only-of-type) {
    grid-template-columns: 1fr !important;
    max-width: 350px !important;
    margin: 0 auto !important;
  }

  /* 2 items */
  .offers-containers:has(.offers-cards:nth-child(2):last-child) {
    grid-template-columns: repeat(2, minmax(300px, 1fr)) !important;
    max-width: 800px !important;
  }

  /* 3 items */
  .offers-containers:has(.offers-cards:nth-child(3):last-child) {
    grid-template-columns: repeat(3, minmax(250px, 1fr)) !important;
    max-width: 1500px !important;
  }

  /* 4 items */
  .offers-containers:has(.offers-cards:nth-child(4):last-child) {
    grid-template-columns: repeat(4, minmax(250px, 1fr)) !important;
    max-width: 1500px !important;
  }

  /* 5+ items - 3 columns for large screens */
  .offers-containers:has(.offers-cards:nth-child(5)) {
    grid-template-columns: repeat(3, minmax(250px, 1fr)) !important;
    max-width: 1500px !important;
    padding-bottom: 100px !important;
  }

  .offers-cards {
    width: 100% !important;
    max-width: 100% !important;
  }
}

/* Extra Large Screens (1800px and above) → 4 columns */
@media (min-width: 1800px) {
  .offers-containers:has(.offers-cards:nth-child(5)) {
    grid-template-columns: repeat(4, minmax(250px, 1fr)) !important;
    max-width: 1800px !important;
  }
}


/* Responsive breakpoints */
@media (max-width: 1024px) {
  /* Tablet - Force 2 columns for 3+ items */
  .offers-containers:has(.offers-cards:nth-child(3)) {
    grid-template-columns: repeat(2, minmax(250px, 1fr));
  }
  
  .offers-containers:has(.offers-cards:nth-child(4)) {
    grid-template-columns: repeat(3, minmax(200px, 1fr)) !important;
  }
}

@media (max-width: 768px) {
  /* Mobile - Single column */
  .offers-containers {
    grid-template-columns: 1fr !important;
    max-width: 500px !important;
    margin: 0 auto !important;
    gap: 50px !important;
  }
  
  .offer-image {
    height: 200px !important;
  }
  
  .card-body {
    padding: 20px !important;
  }
}

/* Empty state handling */
.offers-containers:empty::before {
  content: "No items available";
  text-align: center;
  color: #666;
  font-size: 18px;
  padding: 40px;
}

/* Smooth loading transitions */
.offers-cards {
  animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Rest of your existing CSS remains the same */
.two-buttons button{
  width:150px;
}

/* Extra Small Devices (0px - 425px) */
/* Small Devices (426px - 768px) */
@media (min-width: 426px) and (max-width: 768px) {
}

@media (max-width: 768px) {
  .offers-containers {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
  }
  .offers-cards {
    width: 100% !important;
    max-width: 100% !important;
  }
  .responsive-button-group {
    flex-direction: column !important;
    align-items: center !important;
    width:90vw !important;
  }
  .responsive-button {
    width: 90% !important;
    text-align: center;
  }
  .custom-switch-wrapper {
    margin-top: -70px;
    left: "-20px"
  }
}

@media (max-width: 425px) {
  .custom-switch-wrapper {
    margin-top: -50px;
    left: "-20px"
  }
}

@media (min-width: 980px) {
  .dst{
    margin-left:-11px !important;
  }
  .custom-switch-wrapper {
    margin-left: -20px !important;
  }
}

@media (max-width: 480px) {
  .offers-containers {
    grid-template-columns: 1fr !important;
    width: 300px;
  }
  .offers-cards {
    margin: 0 auto !important;
  }
  .card-body {
    padding: 10px !important;
  }
  .card-title {
    font-size: 18px !important;
  }
}

@media (max-width: 320px) {
  .offers-cards {
    width: 95% !important;
  }
  .card-body {
    padding: 8px !important;
  }
  .card-title {
    font-size: 16px !important;
  }
}

.custom-switch {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 35px;
}

.custom-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-slideryy {
  position: absolute;
  cursor: pointer;
  transition: 0.4s;
  font-weight: bold;
  font-size: 14px;
  color: #000;
  text-align: center;
  line-height: 35px;
  width: 100px;
  height: 40px;
  border-radius: 5px;
  background-color: rgb(217, 217, 217);
}

.custom-slideryy::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  top: 10px;
  background-color: #000;
  transition: 0.4s;
  border-radius: 50%;
}

.custom-slideryy.veg::before {
  background-color: green;
}

.custom-slideryy.non-veg::before {
  background-color: red;
}

.custom-switch input:checked + .custom-slideryy::before {
  transform: translateX(60px);
}

/* Button Base Styles */
.four-buttons button {
  width: 140px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: static !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
}

/* Mobile Responsive - 425px and below */
@media (max-width: 425px) {
  .four-buttons {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 15px !important;
    justify-items: center;
    top: 20px !important;
    width: 100%;
    max-width: 300px;
    margin: 0 auto 30px auto !important;
    padding: 0 10px;
    position: relative !important;
  }
  
  .four-buttons button {
    width: 130px !important;
    height: 55px !important;
    font-size: 1.1rem !important;
    margin: 0 !important;
    position: static !important;
  }
}

/* Small Devices (426px - 768px) */
@media (min-width: 426px) and (max-width: 768px) {
  .four-buttons {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 15px;
    top: 20px;
    width: 100%;
    padding: 0 15px;
    justify-content: center;
    margin-bottom: 25px;
  }
  
  .four-buttons button {
    width: 140px !important;
    height: 55px !important;
    font-size: 1.1rem !important;
    position: static !important;
  }
}

/* Tablet Responsive (769px - 1024px) */
@media (min-width: 769px) and (max-width: 1024px) {
  .four-buttons {
    gap: 15px;
    top: 25px;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 30px;
  }
  
  .four-buttons button {
    width: 140px !important;
    height: 55px !important;
    font-size: 1.1rem !important;
  }
}

/* Large Screens (1025px and above) */
@media (min-width: 1025px) {
  .four-buttons {
    gap: 20px;
    top: 30px;
    flex-direction: row;
    flex-wrap: nowrap;
    margin-bottom: 35px;
  }
  
  .four-buttons button {
    width: 160px !important;
    height: 65px !important;
    font-size: 1.3rem !important;
  }
    .offers-containers {
    padding-bottom: 60px !important; /* Add this */
  }
}

/* Extra Small Devices (320px - 425px) */
@media (max-width: 425px) {
  .four-buttons {
    top: 15px;
    gap: 12px;
  }
  
  .four-buttons button {
    height: 50px !important;
    font-size: 1rem !important;
  }
}

/* Ensure the parent container doesn't have overflow issues */
.responsive-button-group {
  width: 100%;
  position: relative;
}

.custom-switch-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

/* Four Buttons Container */
.four-buttons {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 30px 0;
  position: relative;
}

/* Button Base Styles */
.four-buttons button {
  min-width: 140px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: static !important;
}

/* Mobile Responsive - 425px and below */
@media (max-width: 425px) {
  .four-buttons {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 12px !important;
    justify-items: center;
    margin: 20px auto !important;
    padding: 0 10px;
    max-width: 300px;
  }
  
  .four-buttons button {
    width: 100% !important;
    min-width: unset !important;
    height: 50px !important;
    font-size: 1rem !important;
    margin: 0 !important;
  }
}

/* Small Devices (426px - 768px) */
@media (min-width: 426px) and (max-width: 768px) {
  .four-buttons {
    gap: 15px;
    margin: 25px 0;
    padding: 0 15px;
  }
  
  .four-buttons button {
    min-width: 140px;
    height: 55px;
    font-size: 1.1rem;
  }
}

/* Tablet and Desktop (769px and above) */
@media (min-width: 769px) {
  .four-buttons {
    gap: 20px;
    margin: 20px 0 10px 0;
    flex-wrap: nowrap;
  }
  
  .four-buttons button {
    min-width: 100px;
    height: 65px;
    font-size: 1.3rem;
  }
}

/* Ensure parent containers don't cause issues */
.responsive-button-group {
  width: 100%;
  display: flex;
  justify-content: center;
}

.custom-switch-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.offers-cards {
  margin-bottom: 60px !important;
  // margin-top:-30px !important;
}
  /* Custom resolution: 1000px */
@media (min-width: 992px) and (max-width: 1100px) {
  .main-layout {
    height: calc(100vh - 38px) !important;
    overflow: hidden !important;
  }
  
  .sidebar {
    width: 22% !important;
    flex: 0 0 22% !important;
    max-width: 220px;
    margin-top: 15px;
  }
  
  .main-content {
    width: 56% !important;
    flex: 0 0 56% !important;
    margin-top: 25px;
    padding: 0 15px;
    overflow-y: auto !important;
  }

  .right-offers {
    width: 22% !important;
    flex: 0 0 22% !important;
  }

  /* Menu items grid optimization */
  .offers-containers {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 20px !important;
  }

    // .offers-cards {
    //     min-height: 365px;
    // }

  .offer-image {
    height: 160px !important;
  }

  /* Sidebar category cards */
  .sidebar .card {
    width: 170px !important;
    padding: 12px !important;
  }

  .sidebar .card img {
    width: 85px !important;
    height: 85px !important;
  }

  /* Button sizes */
  .four-buttons button {
    width: 140px !important;
    height: 55px !important;
    font-size: 1.1rem !important;
    padding: 12px 20px !important;
  }

  /* Text sizes */
  .card-title {
    font-size: 18px !important;
  }

  .card-body span[style*="color: gray"] {
    font-size: 16px !important;
  }

  .card-body span[style*="margin-left: 15px"] {
    font-size: 18px !important;
  }
}
  /* Custom resolution: 1000px - Modal Styles */
@media (min-width: 992px) and (max-width: 1100px) {
  /* View Cart Modal */
  .ReactModal__Content--view-cart {
    width: 85% !important;
    max-width: 450px !important;
    height: 80px !important;
    top: 30% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    border-radius: 12px !important;
    padding: 0 !important;
    border: 2px solid #b15cd6 !important;
    box-shadow: 0 8px 25px rgba(177, 93, 198, 0.3) !important;
    bottom: 0px !important;
  }

  .ReactModal__Content--view-cart > div {
    padding: 15px 20px !important;
    height: 75% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }

  /* Modal content sizing */
  .ReactModal__Content--view-cart .MuiSvgIcon-root {
    font-size: 28px !important;
    margin-right: 12px !important;
  }

  .ReactModal__Content--view-cart div[style*="font-size: 24px"] {
    font-size: 20px !important;
    margin-right: 12px !important;
  }

  .ReactModal__Content--view-cart button {
    padding: 10px 20px !important;
    font-size: 14px !important;
    border-radius: 25px !important;
    min-width: 100px !important;
  }

  /* Add to Cart Success Modal (existing one) */
  .ReactModal__Content {
    width: 85% !important;
    max-width: 480px !important;
    height: 100px !important;
    bottom: 0px !important;
    top: auto !important;
    left: 50% !important;
    transform: translateX(-30%) !important;
    border-radius: 12px !important;
    padding: 0 !important;
  }

  .ReactModal__Content > div {
    padding: 15px 20px !important;
    height: 80% !important;
  }

  .ReactModal__Content .MuiSvgIcon-root {
    font-size: 26px !important;
    margin-right: 12px !important;
  }

  .ReactModal__Content div[style*="font-size: 24px"] {
    font-size: 18px !important;
    margin-right: 10px !important;
  }

  .ReactModal__Content button {
    padding: 8px 18px !important;
    font-size: 14px !important;
  }
}
  @media (min-width: 769px) and (max-width: 819px) {
    .menuiteams-data {
        margin-top: 20px !important;
        padding: 0px 19px;
        width: 86%;
        left: -34px;
        position: relative;
    }
}
@media (min-width: 820px) and (max-width: 850px) {
  .menuiteams-data {
        margin-top: 20px !important;
        padding: 0px 19px;
        width: 90%;
        left: -20px;
        position: relative;
  }
}
@media (min-width: 851px) and (max-width: 900px) {
  .menuiteams-data {
        margin-top: 20px !important;
        padding: 0px 19px;
        width: 90%;
        left: -20px;
        position: relative;
  }
}
  @media (min-width : 1381px){
  .offers-containers:has(.offers-cards:only-of-type) {
  
    justify-content: start;
  }
  }
  
/* Custom resolution: 1320px - 1380px */
@media (min-width: 1320px) and (max-width: 1380px) {
  .offers-containers {
    grid-template-columns: repeat(auto-fit, minmax(300px, 300px));
    justify-content: center;
    gap: 25px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px 0;
  }

  /* 1 Item - Exactly 300px */
  .offers-containers:has(.offers-cards:only-of-type) {
    grid-template-columns: 300px;
    max-width: 300px;
    justify-content: start;
  }

  /* 2 Items - 2 columns of exactly 300px */
  .offers-containers:has(.offers-cards:nth-child(2):last-child) {
    grid-template-columns: repeat(2, 300px);
    max-width: 625px; /* 300px * 2 + 25px gap */
    justify-content: start;
  }

  /* 3 Items - 3 columns of exactly 300px */
  .offers-containers:has(.offers-cards:nth-child(3):last-child) {
    grid-template-columns: repeat(3, 300px);
    max-width: 925px; /* 300px * 3 + 25px * 2 gaps */
  }

  /* 4 Items - 4 columns of exactly 300px */
  .offers-containers:has(.offers-cards:nth-child(4):last-child) {
    grid-template-columns: repeat(4, 300px);
    max-width: 1225px; /* 300px * 4 + 25px * 3 gaps */
  }

  /* 5+ Items - Auto-fit but fixed 300px width */
  .offers-containers:has(.offers-cards:nth-child(5)) {
    grid-template-columns: repeat(auto-fit, 290px);
    max-width: 1225px;
    justify-content: center;
  }

  /* Force all cards to be exactly 300px width */
  .offers-cards {
    width: 300px !important;
    max-width: 300px !important;
    min-width: 300px !important;
  }

  /* Ensure images don't exceed card width */
  .offer-image {
    width: 300px !important;
    max-width: 300px !important;
    height: 200px !important;
    object-fit: cover;
  }

  /* Card body fixed width */
  .card-body {
    width: 300px !important;
    max-width: 300px !important;
    box-sizing: border-box;
  }

  /* Image height adjustments for different card counts */
  .offers-containers:has(.offers-cards:only-of-type) .offer-image {
    height: 220px !important;
  }

  .offers-containers:has(.offers-cards:nth-child(2):last-child) .offer-image,
  .offers-containers:has(.offers-cards:nth-child(3):last-child) .offer-image,
  .offers-containers:has(.offers-cards:nth-child(4):last-child) .offer-image {
    height: 180px !important;
  }

  .offers-containers:has(.offers-cards:nth-child(5)) .offer-image {
    height: 170px !important;
  }
}

  
`}
        </style>

        <div className="responsive-button-group menu-responsive-buttons-code" style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <div className="custom-switch-wrapper" style={{ position: "relative", width: "100%" }}>
            <button
              onClick={() => navigate("/homepage")}
              style={{
                position: "absolute",
                left: "1%",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "rgb(177, 92, 214)",
                fontSize: isMobile ? "16px" : "18px",
                display: isMobile ? "none" : "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <ArrowBack style={{ fontSize: isMobile ? "20px" : "24px" }} />
              Back
            </button>
            <div className='four-buttons'>
              {/* Dining Button - GREEN */}
              <button
                onClick={() => handleOrderTypeClick("Dining")}
                style={{
                  padding: "0.9rem 1.5rem",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  borderRadius: "12px",
                  border: "3px solid #28a745",
                  background: orderType === "DINE_IN" ? "#28a745" : "#ffffff",
                  color: orderType === "DINE_IN" ? "#ffffff" : "#28a745",
                  boxShadow: orderType === "DINE_IN" ? "0 6px 15px rgba(40, 167, 69, 0.4)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "all 250ms ease-in-out",
                  outline: "none",
                }}
              >
                Dine In
              </button>

              {/* Takeaway Button - RED */}
              <button
                onClick={() => handleOrderTypeClick("Takeaway")}
                style={{
                  padding: "15px 32px",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  borderRadius: "12px",
                  border: "3px solid #dc3545",
                  background: orderType === "TAKEAWAY" ? "#dc3545" : "#ffffff",
                  color: orderType === "TAKEAWAY" ? "#ffffff" : "#dc3545",
                  boxShadow: orderType === "TAKEAWAY" ? "0 6px 15px rgba(220, 53, 69, 0.4)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "all 250ms ease-in-out",
                  outline: "none",
                }}
              >
                Takeaway
              </button>

              {/* Veg Button - GREEN */}
              <button
                onClick={() => handleFilterClick("Veg")}
                style={{
                  padding: "15px 32px",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  borderRadius: "12px",
                  border: "3px solid #28a745",
                  background: isVegSelected ? "#28a745" : "#ffffff",
                  color: isVegSelected ? "#ffffff" : "#28a745",
                  boxShadow: isVegSelected ? "0 6px 15px rgba(40, 167, 69, 0.4)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "all 250ms ease-in-out",
                  outline: "none",
                }}
              >
                Veg
              </button>

              {/* Non-Veg Button - RED */}
              <button
                onClick={() => handleFilterClick("Non-Veg")}
                style={{
                  padding: "15px 32px",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  borderRadius: "12px",
                  border: "3px solid #dc3545",
                  background: isNonVegSelected ? "#dc3545" : "#ffffff",
                  color: isNonVegSelected ? "#ffffff" : "#dc3545",
                  boxShadow: isNonVegSelected ? "0 6px 15px rgba(220, 53, 69, 0.4)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "all 250ms ease-in-out",
                  outline: "none",
                }}
              >
                Non-Veg
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row"></div>

      <div className="offers-containers" style={{ marginTop: "-50px" }}>
        {filteredDishes.map((item) => {
          return (
            <div key={item.dishId} className="offers-cards">
              <div className="inner-box" style={{ position: 'relative' }}>
                {item.dishImage ? (
                  <img
                    src={item.dishImage}
                    alt="Dish"
                    className="offer-image"
                  />
                ) : (
                  <img
                    src="default-image.jpg"
                    alt="Default"
                    className="offer-image"
                  />
                )}
              </div>

              <div
                className="card-body"
                style={{
                  marginTop: "8px",
                  padding: "15px",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    top: "15px",
                  }}>
                  <h5
                    className="card-title text-dark"
                    style={{
                      fontSize: "20px",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <span style={{ flex: 1 }}>{item.dishName}</span>

                    <div
                      style={{
                        marginLeft: "10px",
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        cursor: "pointer",
                        fontStyle: "italic",
                        position: "relative",
                      }}
                      onClick={() => handleToggleTooltip(item.dishId)}
                    >
                      i
                      {activeTooltip === item.dishId && (
                        <div
                          style={{
                            position: "absolute",
                            top: "-127px",
                            right: "-23px",
                            backgroundColor: "#fff",
                            color: "#333",
                            padding: "16px 18px",
                            borderRadius: "10px",
                            fontSize: "15px",
                            fontWeight: "400",
                            lineHeight: "1.6",
                            boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
                            whiteSpace: "normal",
                            width: "215px",
                            zIndex: 100,
                            border: "1px solid #eee",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "-10px",
                              right: "15px",
                              width: "0",
                              height: "0",
                              borderLeft: "10px solid transparent",
                              borderRight: "10px solid transparent",
                              borderBottom: "10px solid #fff",
                              filter: "drop-shadow(0 -2px 2px rgba(0,0,0,0.1))",
                            }}
                          ></div>

                          <h4
                            style={{
                              margin: "0 0 8px",
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#222",
                            }}
                          >
                            {item.dishName || "Dish Details"}
                          </h4>
                          <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                            {item.description
                              ?.trim()
                              ? item.description
                              : "This dish is very tasty and popular."}
                          </p>
                        </div>
                      )}
                    </div>

                    {item.tag === "Veg" ? (
                      <span
                        style={{
                          display: "inline-block",
                          width: "18px",
                          height: "18px",
                          border: "2px solid green",
                          borderRadius: "2px",
                          marginLeft: "12px",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            display: "block",
                            width: "9px",
                            height: "9px",
                            backgroundColor: "green",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        ></span>
                      </span>
                    ) : (
                      <span
                        style={{
                          display: "inline-block",
                          width: "18px",
                          height: "18px",
                          border: "2px solid red",
                          borderRadius: "2px",
                          marginLeft: "12px",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            display: "block",
                            width: "9px",
                            height: "9px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        ></span>
                      </span>
                    )}
                  </h5>
                </div>

                <span className="d-flex justify-content-between" style={{ color: 'black', marginTop: "15px" }}>
                  <span>
                    <span style={{ position: 'relative', fontSize: '21px', color: "gray" }}>
                      <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '15px' }}></i>
                      {item.price}
                      <span style={{
                        content: '',
                        position: 'absolute',
                        top: '15px',
                        left: 0,
                        width: '100%',
                        borderTop: '1px solid black',
                      }} />
                    </span>

                    <span style={{ fontSize: '20px', position: 'relative', marginLeft: '15px' }}>
                      <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "15px" }}></i>
                      {(item.effectivePrice).toFixed(2)}
                    </span>
                  </span>
                  <i
                    className="fa-regular fa-heart fs-5"
                    style={{ marginTop: '10px', cursor: 'pointer', color: '#b15dc6' }}
                    title="Add to favorites"
                    onClick={() => {
                      console.log("🔴 DIRECT DEBUG BEFORE PASSING:");
                      console.log("Current item.dishId:", item.dishId);
                      console.log("Current item.dishName:", item.dishName);
                      console.log("About to call handleAddToFavorites with:", item.dishId);
                      handleAddToFavorites(item.dishId);
                    }}
                  />
                </span>

                <br></br>

                {userId && quantities[item.dishId] > 0 ? (
                  <div
                    className="d-flex justify-content-between align-items-center border p-2 mt-2"
                    style={{
                      borderRadius: '50px',
                      backgroundColor: '#b15dc6',
                      width: '80%',
                      height: '37px',
                      marginLeft: '38px',
                    }}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        openModal(item);
                        decreaseQuantity(item);
                      }}
                      style={{
                        width: '40px',
                        height: '40px',
                        fontWeight: 'bold',
                        fontSize: '25px',
                        color: '#fff',
                        marginTop: '-10px',
                        border: '#fff',
                      }}
                    >
                      -
                    </button>

                    <span
                      style={{
                        fontSize: '25px',
                        fontWeight: 'bold',
                        minWidth: '40px',
                        textAlign: 'center',
                        color: '#fff',
                      }}
                    >
                      {quantities[item.dishId]}
                    </span>

                    <button
                      className="btn"
                      onClick={() => {
                        openModal(item);
                        increaseQuantity(item.dishId);
                      }}
                      style={{
                        width: '40px',
                        height: '40px',
                        fontSize: '25px',
                        fontWeight: 'bold',
                        color: '#fff',
                        marginTop: '-10px',
                        border: '#fff',
                      }}
                    >
                      +
                    </button>
                  </div>
                ) : (
                  <button
                    className="btn mt-2 d-block mx-auto"
                    onClick={() => {
                      if (!userId) {
                        setShowLogin(true);
                        return;
                      }
                      openModal(item);
                      setQuantities((prevQuantities) => ({
                        ...prevQuantities,
                        [item.dishId]: 1,
                      }));
                      addToCart(item, 1);
                    }}
                    style={{
                      background: '#b15dc6',
                      color: '#fff',
                      width: '80%',
                    }}
                  >
                    Add To Cart
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal */}
      {/* Modal */}
      <Modal
        // className="ReactModal__Content--view-cart" // Add this class
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Add to Cart"
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            backgroundColor: "transparent",
            pointerEvents: "none",
          },
          content: {
            pointerEvents: "auto",
            position: "absolute",
            top: (window.innerWidth <= 425) ? "95%" : "92%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "500px",
            border: "none",
            boxShadow: "none",
            padding: "0px",
            height: "80px",
            borderRadius: "10px",
          },
          zIndex: 10000,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: (window.innerWidth <= 425) ? "10px 10px" : "10px 20px",
            width: "100%",
            fontWeight: "bold",
            color: "#333",
            borderRadius: "10px",
            height: "80px",
            border: "2px solid #b15cd6",
            background: "#fff"
          }}
        >
          <ShoppingCart style={{ fontSize: "30px", color: "#b15dc6", marginRight: "15px" }} />

          <div
            style={{
              marginRight: (window.innerWidth <= 425) ? "5px" : "15px",
              fontSize: (window.innerWidth <= 425) ? "17px" : "24px",
            }}>
            {/* Calculate total items from quantities state */}
            ({Object.values(quantities).reduce((acc, qty) => acc + qty, 0)}) Items
          </div>

          <div style={{
            marginRight: (window.innerWidth <= 425) ? "5px" : "15px",
            fontSize: (window.innerWidth <= 425) ? "17px" : "24px",
          }}>
            Total: ₹
            {/* Calculate total price from dishes and quantities */}
            {Object.entries(quantities)
              .reduce((acc, [dishId, quantity]) => {
                const dish = dishes.find(d => d.dishId == dishId);
                if (dish && quantity > 0) {
                  return acc + (dish.effectivePrice * quantity);
                }
                return acc;
              }, 0)
              .toFixed(2)}
          </div>

          <button
            style={{
              borderRadius: "50px",
              background: "#b15dc6",
              color: "#fff",
              padding: (window.innerWidth <= 425) ? "0px 20px" : "8px 16px",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={handleViewCartClick}
          >
            View Cart
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default MenuitemsTable;